import http from './http';

const httpPut = async (url, data = undefined, config = undefined) => {
  const response = await http.put(url, data, config);
  return response.data;
};

export default httpPut;
